import { useCallback, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { getRequestContext } from '@/shared/lib/requestContext';

type PickupFilters = Partial<{
    hasFittingRoom: boolean;
    hasPaymentOnDelivery: boolean;
}>;

export type PickupFilterKeys = keyof PickupFilters;

export const usePickupFilters = () => {
    const {
        delivery: { disableOnlinePayment },
    } = getRequestContext();

    const [pickupFilters, setPickupFilters] = useState<PickupFilters>({
        ...(disableOnlinePayment ? { hasPaymentOnDelivery: true } : {}),
    });

    const changePickupFilters = useCallback(
        <T extends PickupFilterKeys>(filter: T, value: PickupFilters[T]) => {
            const { [filter]: currentValue, ...other } = pickupFilters;

            if ((currentValue && currentValue !== value) || !currentValue) {
                if (!value && isEmpty(value)) {
                    setPickupFilters(other);
                } else {
                    setPickupFilters({ ...other, [filter]: value });
                }
            } else {
                setPickupFilters(other);
            }
        },
        [pickupFilters]
    );

    return {
        pickupFilters,
        changePickupFilters,
    };
};
